import "./index.css";
import { useTranslation } from "react-i18next";
import { Button, Checkbox, Modal } from "@/ui-kit";
import { useCallback, useMemo, useState } from "react";
import { UsersRepository } from "@/api/users/repository";
import { UsersService } from "@/api/users/service";
import { serverErrorHandler } from "@/utils/serverErrorHandler";

type IProps = {
  onSuccess: () => void;
};

export const PrivacyConsentModal = ({ onSuccess }: IProps) => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const usersRepository = useMemo(() => {
    return new UsersRepository(new UsersService());
  }, []);

  const handleSubmit = useCallback(() => {
    setLoading(true);
    usersRepository
      .postPrivacyConsent()
      .then(() => {
        onSuccess();
      })
      .catch(
        serverErrorHandler(() => {
          setChecked(false);
        }),
      );
  }, [usersRepository, onSuccess]);

  return (
    <Modal
      open={true}
      onOpenChange={() => {}}
      showClose={false}
      closeOnOutsidePress={false}
      title={t("label.privacyConsent.title")}
      footer={
        <Button
          disabled={!checked}
          loading={loading}
          onClick={handleSubmit}
          content={t("label.privacyConsent.agreeAndContinue")}
        />
      }
      className="privacy-consent__modal"
    >
      <Checkbox
        checked={checked}
        onChange={setChecked}
        color="layer1"
        label={t("label.privacyConsent.consentText")}
      />
    </Modal>
  );
};
